module.exports = __webpack_public_path__ + "static/media/person4.10513ae1.jpeg";